import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Searchbar } from 'ionic-angular';
import * as JsSearch from 'js-search';
import { IoDiagnosis, IoEffect, IoDrugGroup, IoDrug, LinkedEffect, LinkedIoEffect } from '../../types';
import { DataProvider, sort, getNormalizedNameForSorting, compareOrdered } from '../../providers/data/data';
import { DrugCategoryPage } from '../drug-category/drug-category';
import { AnalyticsProvider } from '../../providers/analytics/analytics';
import * as _ from 'lodash';
import { DrugDetailPage } from '../drug-detail/drug-detail';
import { DrugFilterSettings, FilterSettingsComponent } from '../../components/filter-settings/filter-settings';
import { SettingsProvider } from '../../providers/settings/settings';
import { DrugDataStore } from '../../providers/data/drug-data-store';

/**
 * Generated class for the CombinedResultsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-combined-results',
  templateUrl: 'combined-results.html',
})
export class CombinedResultsPage {

  selected: IoDiagnosis;
  effectsIndex: JsSearch.Search;
  groupsIndex: JsSearch.Search;
  allEffects: Array<LinkedIoEffect>;
  allGroups: Array<IoDrugGroup>;

  filteredEffects: Array<LinkedIoEffect> = [];
  filteredGroups: Array<IoDrugGroup> = [];

  prefilter: 'drugs' | 'categories' = 'drugs';
  filterSettings: DrugFilterSettings = { showTrademarks: true };

  @ViewChild('searchbar') searchbar: Searchbar;

  constructor(public navCtrl: NavController, public navParams: NavParams, private analytics: AnalyticsProvider,
    private dds: DrugDataStore,
    settingsProvider: SettingsProvider) {
    this.selected = this.navParams.data;

    const showTrademarksRemembered = settingsProvider.getLocalBool(FilterSettingsComponent.showTrademarksSettingsKey);
    if (showTrademarksRemembered !== null) {
      this.filterSettings.showTrademarks = showTrademarksRemembered;
    }
  }

  ionViewDidLoad() {
    this.effectsIndex = DataProvider.createIndex('id', ['drug', 'name']);
    this.effectsIndex.addIndex(['drug', 'registrationInfo']);
    this.groupsIndex = DataProvider.createIndex('id', 'name');

    this.allEffects = this.dds.getLinkedEffectsOfDiagnosis(this.selected);
    this.allGroups = _.uniq(_.flatMap(this.allEffects, effect => this.dds.getGroupsOfDrug(effect.drug)));

    sort(this.allGroups)

    this.effectsIndex.addDocuments(this.allEffects);
    this.groupsIndex.addDocuments(this.allGroups);
    this.filterItems();
  }

  filterItems() {
    let val = this.searchbar.value;
    val = (val || '').trim();

    if (val) {
      this.analytics.emitEvent('combinedResults', 'searchInputLength', val.length + '');
      this.filteredEffects = this.effectsIndex.search(val) as Array<LinkedIoEffect>;

      // sort. This is needed because original order gets lost when searching
      this.filteredEffects.sort((a, b) => {
        return compareOrdered(a.drug, b.drug)
      });
      this.filteredGroups = this.groupsIndex.search(val) as Array<IoDrugGroup>;
    } else {
      this.analytics.emitEvent('combinedResults', 'searchReset');
      this.filteredEffects = this.allEffects;
      this.filteredGroups = this.allGroups;
    }

    if (!this.filterSettings.showTrademarks) {
      this.filteredEffects = this.filteredEffects.filter(e => !e.drug.isTrademark)
    }

    this.dds.calculateEffectStatsWhereMissing(this.filteredEffects.map(e => e.drug));
  }

  onPrefilterChange(value: string) {
    this.analytics.emitEvent('combinedResults', 'prefilter', value);
  }

  drugClicked(drug: IoDrug) {
    this.analytics.emitEvent('combinedResults', 'drugSelected');
    this.navCtrl.push(DrugDetailPage, [drug, this.selected]);
  }

  groupClicked(group: IoDrugGroup) {
    this.analytics.emitEvent('combinedResults', 'categorySelected');
    this.navCtrl.push(DrugCategoryPage, [group, this.selected]);
  }

  handleSettingsChanged(settings: DrugFilterSettings) {
    this.filterSettings = settings;
    this.filterItems();
  }

  ionViewDidEnter() {
    if (this.prefilter === 'drugs' && this.filteredEffects.length < 20) {
      return;
    }
    if (this.prefilter === 'categories' && this.filteredGroups.length < 20) {
      return;
    }

    setTimeout(() => {
      this.searchbar.setFocus();
    }, 150);
  }

}



// WEBPACK FOOTER //
// ./src/pages/combined-results/combined-results.ts